<template>
  <supplierdeductionadjust-check
    :sna-id="snaId"
    :pagetitle="`供应商抵扣金额调整审批详情`"
  >
  </supplierdeductionadjust-check>
</template>

<script>
import checkMixin from '@/mixin/checkMixin'
import supplierdeductionadjustCheck
  from '@/views/workbench/workCheckManage/supplierdeductionadjustCheck/supplierdeductionadjustCheck'
import routerMixin from '@/mixin/routerMixin'
export default {
  name: 'supplierdeductionadjustCheckDetail',
  mixins: [checkMixin, routerMixin],
  components: { supplierdeductionadjustCheck }
}
</script>

<style scoped>

</style>
